var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1151({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "6.79 15 6.79 11.95 6.79 4.79 5 4.79 8 1 11 4.79 9.21 4.79 9.21 11.95 9.21 15 6.79 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1151);
export default __webpack_public_path__ + "static/media/Symbolpack_1_151.1a8928b86b9788682535cd7b3ab39ab0.svg";
export { ForwardRef as ReactComponent };